<template>
    <div class="product-kits-modal">
        <h2 class="product-kits-modal__title">
            {{ messages.kitAddTitle }}
        </h2>
        <h6 class="kits-modal-sub-title">
            <svg class="kits-modal-sub-title__icon">
                <use xlink:href="#svg-basket"></use>
            </svg>
            <span class="kits-modal-sub-title__text">
                {{ messages.kitAdd }} {{ kits?.length }} {{ messages.kitProductAmount }} {{ getPrice }} грн.
            </span>
        </h6>
        <PerfectScrollbar class="product-kits-modal__products">
            <ProductKitsModalCard
                v-for="(item, key) in savedKits"
                :key="item?.offer?.id || item?.id"
                :result="item"
                @changeSKU="changeSKU($event, key)"
            />
        </PerfectScrollbar>
        <ProductKitsBottom
            :result="result"
            :kits="savedKits"
            @saveKits="saveKits"
        />
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';

export default {
    name: 'ProductKitsModal',
    props: ['kits', 'result'],
    data() {
        return {
            savedKits: [...this.kits],
        }
    },
    computed: {
        ...mapState({
            createOrder: ({ basket }) => basket.data.routes.createOrder,
            messages: ({ product }) => product?.data?.product?.kits?.messages,
        }),
        getKitsIds() {
            return this.savedKits.map(el => el?.offer?.id || el?.id);
        },
        getPrice() {
            const totalPrice = this.savedKits.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.price.price;
            }, 0).toFixed(2);

            return App.helpers.formatPrice(totalPrice);
        },
    },
    methods: {
        ...mapMutations({
            loaderStart: 'global/loaderStart',
            loaderStop: 'global/loaderStop',
        }),
        ...mapActions({
            addToBasket: 'basket/add',
        }),
        async changeSKU(detailPage, key) {
            try {
                this.loaderStart();
                const { data: responseData, status } = await axios.get(detailPage + '&api=y');

                if (status !== 200) throw `Bad request response status ${ status }`;

                this.savedKits.splice(key, 1, responseData.product);
            } catch (err) {
                console.error(err);
            }
            finally {
                this.loaderStop();
            }
        },
        async saveKits() {
            try {
                this.loaderStart();
                await this.addToBasket({ id: this.getKitsIds });
                this.$DefModal.hide();
                location.href = this.createOrder.path;
            } catch (err) {
                console.error(err);
            } finally {
                this.loaderStop();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.product-kits-modal{
    padding: 48px 16px 24px 16px;
    @include point-md{
        padding: 26px;
    }
    @include point-lg{
        padding: 48px;
    }
    &__title{
        font-weight: 500;
        line-height: 100%;
        margin-bottom: 8px;
        font-size: rem(18);
        text-align: center;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        @include point-md{
            font-size: rem(20);
            text-align: left;
        }
        @include point-lg{
            font-size: rem(24);
        }
    }
    &__products{
        display: grid;
        grid-row-gap: 8px;
        position: relative;
        overflow-y: auto;
        max-height: 280px;
    }
}
.kits-modal-sub-title{
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #191918;
    margin-bottom: 32px;
    @include point-md{
        justify-content: flex-start;
        margin-bottom: 24px;
        font-size: 16px;
        line-height: 16px;
    }
    &__icon{
        display: block;
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }
    &__text{
        transform: translateY(3px);
    }
}
</style>